import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

const StyledSection = styled.section`
  color: white;
  background-size: cover;
  background-position: top right;
  background-repeat: no-repeat;
  background-image: url(images/butterfly-bg.png);
  background-color: black;

  h3 {
    margin-bottom: 30px;
  }

  .MuiCard-root {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    padding-top: 75%;
    height: 100%;
    display: flex;
  }

  .MuiCardContent-root {
    background-color: rgba(0, 65, 92, 0.9);
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h4 {
      margin-bottom: 15px;
    }

    p {
      margin-bottom: 30px;
    }
  }

  .MuiCardActions-root {
    padding: 0;
  }
`
const Services = () => {
  const history = useHistory()

  return (
    <StyledSection>
      <Container style={{ minHeight: 'unset' }}>
        <h3>Our services</h3>
        <Grid container spacing={5}>
          <Grid item sm={6} xs={12}>
            <Card
              style={{
                backgroundImage:
                  'url(images/homepage/services/contract-programming.jpg)',
              }}
            >
              <CardContent>
                <div className="content">
                  <h4>Programming services</h4>
                  <p>
                    Getting expert assistance when you need it is vital to
                    maintaining manufacturing productivity. Whether you need new
                    CMM programs created for a new launch or have your existing
                    CMM programs optimized (cycle time, performance, etc.) when
                    production increases, a quote and program are only a few
                    short steps away.
                  </p>
                </div>
                <CardActions>
                  <Button
                    className="btn-white"
                    onClick={() => history.push('/createaquote/programming')}
                  >
                    Start a quote
                  </Button>
                </CardActions>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Card
              style={{
                backgroundImage:
                  'url(images/homepage/services/contract-inspection.jpg)',
              }}
            >
              <CardContent>
                <div className="content">
                  <h4>Inspection services</h4>
                  <p>
                    You might be down a system, have too much work, or you just
                    plain need somebody to do the work for you. We are here to
                    run full inspection services at one of our fully staffed
                    centers. We can provide an inspection report to optimizing a
                    program to meet desired cycle time or GR&R criteria. A quote
                    is only a few steps away.
                  </p>
                </div>
                <CardActions>
                  <Button
                    className="btn-white"
                    onClick={() => history.push('/createaquote/inspection')}
                  >
                    Start a quote
                  </Button>
                </CardActions>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </StyledSection>
  )
}

export default Services
